import styled from 'styled-components';

import { SmallTitle } from '@genially/design-system';

export const Wrapper = styled.div(({ theme: { size, color } }) => ({
  position: 'fixed',
  inset: 0,
  // Above HostGame's header/sidebars (zIndex 2-3) and ReactionsOverlay (zIndex 10) so it can
  // also be used as a loading overlay on top of an already-mounted view, not just full-page.
  zIndex: 20,

  width: '100%',
  height: '100dvh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  textAlign: 'center',

  gap: size.units(3.5),

  padding: `0 ${size.units(3)}`,

  backgroundColor: color.background.reversed.default(),
}));

export const Title = styled(SmallTitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const LoaderVideo = styled.video(({ theme: { size } }) => ({
  width: size.units(17),
  height: size.units(17),
}));
